import { getSession, getUrlName, isJointTransactionFlow, isMiniCartFooterEnabled } from '../../common/Helpers';
import { generateQueryString } from '../../common/Helpers/queryParams';

export const getBadgeProps = (data) => ({
  title: data?.title,
  subtitle: data?.subtitle,
  badge: data?.badge,
});

export const getHomeLQProperties = (data) => ({
  lqTitle: data?.lqTitle || {},
  theme: data?.theme || {},
  banner: {
    height: data?.banner?.height || '460px',
    color: data?.banner?.color || '#EE0000',
    image: {
      preLQView: data?.banner?.image?.preLQView || {},
    },
  },
  qualificationImages: data?.qualificationImages || {},
});

export const generateOrderHeader = (data = []) => {
  const makeObj = {};
  data.forEach((item) => {
    makeObj[item.key] = item;
  });
  return makeObj;
};

export const generatePerkImage = (image, viewport = 'desktop', aspectratio = '') => {
  console.log('aspectratio', image, aspectratio);
  const ratio = aspectratio || viewport === 'desktop' ? '1x1' : '3x4';
  return `${image?.baseUrl + image?.perkName}-${ratio}-small${generateQueryString(image?.queryParams || {})}`;
};

export const getIsStreamlineMiniCartFFlag = (featureFlags = {}) => {
  const configPages = ['streamlineordering', 'addons', 'setup', 'expresscheckout', 'cart'];
  const AALFooterMiniCartPages = [ 'progressiveplan','addons', 'expresscheckout', 'shipping', 'payment'];
  const enablePlansPageMiniCartFFlag = isMiniCartFooterEnabled();
  const { search } = window.location;
  const params = new URLSearchParams(search);
  const getPageName = getUrlName(window.location.href);
  const isConfigured = configPages.includes(getPageName);
  const isConfiguredForBAU = AALFooterMiniCartPages.includes(getPageName);
  const isMiniCartQueryFlag = params.get('miniCartStreamLine') === 'Y';
  if (enablePlansPageMiniCartFFlag && !isJointTransactionFlow()) {
    return isConfiguredForBAU || sessionStorage?.getItem('AALFooterMiniCart') === 'Y';
  }
  if (!isConfigured) return false;
  return isMiniCartQueryFlag || (featureFlags?.streamlineMinicartFFlag && isConfigured && sessionStorage?.getItem('widgetLQHost') === 'Streamline');
};

export const getSuccessNotificationProps = (cartState, rebateOfferAmount, barCodeApplied, totalDiscount, extraParams) => {
  const {sweetnerGreenBannerText, dynamicOfferBannerText, callBack} = extraParams || {};
  const isLQUpdateOffer = getSession('isLQGCOffer') === 'Y';
  if(!isLQUpdateOffer) {
    return {};
  }
  const singleOffer = rebateOfferAmount &&
      barCodeApplied &&
      cartState?.cartDetailsJson?.orderDetailsView?.cartTotalDiscounts?.discountDetails?.[0]?.discountItems?.length === 1;
  const dynamicOffer = rebateOfferAmount &&
      barCodeApplied &&
      cartState?.cartDetailsJson?.orderDetailsView?.cartTotalDiscounts?.discountDetails?.[0]?.discountItems?.length > 1 &&
      cartState?.cartDetailsJson?.featureFlags?.dynamicGiftOfferFFlag;
  const notificationProps = {};
  if (singleOffer) {
    notificationProps.renderIf = true;
    notificationProps.title = sweetnerGreenBannerText?.replace('{OfferAmount}', rebateOfferAmount);
    notificationProps.type = 'success';
    notificationProps.subtitle = '';
    notificationProps.hideCloseButton = true;
    notificationProps.id="single-offer-notification-gc";
    notificationProps.buttonData = [
      {
        children: 'Details',
        onClick: () => {
          callBack({sweetnerDetailsModal: true});
        },
      },
    ];
  } else if(dynamicOffer) {
      notificationProps.renderIf = true;
      notificationProps.title = dynamicOfferBannerText?.replace('{totalDiscount}', totalDiscount);
      notificationProps.type = 'success';
      notificationProps.subtitle = '';
      notificationProps.hideCloseButton = true;
      notificationProps.id="dynamic-offer-notification-gc";
      notificationProps.buttonData = [
        {
          children: 'Details',
          onClick: () => {
            callBack({isSavingsModal: true});
          },
        },
      ];
  }

  return notificationProps;
}

export const getIsPlansPageMiniCartFFlag = (featureFlags = {}) => {
  const configPages = ["progressiveplan"];
  const getPageName = getUrlName(window.location.href);
  const isConfigured = configPages.includes(getPageName);
  if(!isConfigured) return false;
  return Object.keys(featureFlags).length === 0 ? isConfigured : isMiniCartFooterEnabled() && isConfigured;
};

export const calculateMonthlyDue = (monthlyList = []) => {
  const dueMonthlyList = JSON.parse(JSON.stringify(monthlyList));
  const filterLists = [];
  const getDiscountValue = dueMonthlyList.reduce(
    (acc, item) => {
      const getActualAmount = item.actualAmount;
      const getTotalDiscountAmount = item.totalAmountWithDiscount || getActualAmount;
      const actualAmt = parseFloat(getActualAmount) + acc.actualAmount;
      const discAmt = parseFloat(getTotalDiscountAmount) + acc.discountAmount;
      const discountValue = parseFloat(getActualAmount) - parseFloat(getTotalDiscountAmount);
      if (discountValue > 0) {
        const cloneItem = item;
        cloneItem.discountAmount = discountValue;
        filterLists.push(cloneItem);
      }
      console.log('cartdata', actualAmt, discAmt);
      acc.actualAmount = Number(actualAmt);
      acc.discountAmount = Number(discAmt);
      acc.discountedLists = filterLists;
      return acc;
    },
    { actualAmount: 0.0, discountAmount: 0.0 },
  );
  return {
    savings: (getDiscountValue.actualAmount - getDiscountValue.discountAmount).toFixed(2),
    total: getDiscountValue.actualAmount.toFixed(2),
    monthlyLists: getDiscountValue?.discountedLists || [],
  };
};
